import { Button } from "$components/button/button";
import { DialogBody } from "$components/dialog/dialog-body";
import { DialogContainer } from "$components/dialog/dialog-container";
import { DialogFooter } from "$components/dialog/dialog-footer";
import { DialogHeader } from "$components/dialog/dialog-header";
import { YesNoRadio } from "$components/rhf/yes-no-radio";
import { yupResolver } from "@hookform/resolvers/yup";
import { Typography } from "@material-ui/core";
import { FormProvider, useForm } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { boolean, type InferType, object } from "yup";

const componentName = "WhatsappConsentModal";

export const whatsappConsentModalTestId = {
  container: componentName,
  checkBoxButton: `${componentName}.checkBoxButton`,
  continueButton: `${componentName}.continueButton`,
  cancelButton: `${componentName}.cancelButton`,
};

const formSchema = object({
  consented: boolean().required(),
});

export const WhatsappConsentModal: FC<{
  open: boolean;
  onSubmit: (hasGivenConsent: boolean) => void;
  submitLoading?: boolean;
  onClose?: () => void;
}> = ({ open, onSubmit, submitLoading, onClose }) => {
  const formMethods = useForm<InferType<typeof formSchema>>({
    mode: "onTouched",
    resolver: yupResolver(formSchema),
  });
  return (
    <DialogContainer
      open={open}
      data-testid={whatsappConsentModalTestId.container}
      onClose={onClose}
    >
      <FormProvider {...formMethods}>
        <form
          onSubmit={formMethods.handleSubmit(({ consented }) =>
            onSubmit(consented),
          )}
        >
          <DialogHeader title="">
            <Typography variant="h4">
              <FormattedMessage
                id="user.consent.whatsapp.title"
                defaultMessage="WhatsApp communications consent"
              />
            </Typography>
          </DialogHeader>
          <DialogBody>
            <Typography paragraph>
              <FormattedMessage
                id="user.consent.whatsapp.bodyMessage"
                defaultMessage="Elephant would like to contact you via WhatsApp with relevant product and feature updates that it thinks will be helpful for you. You can change your answers at any time on your User Settings page."
              />
            </Typography>
            <Typography paragraph>
              <FormattedMessage
                id="user.consent.whatsapp.confirm"
                defaultMessage="Do you give your permission for Elephant to contact you via WhatsApp?"
              />
            </Typography>
            <YesNoRadio name="consented" />
          </DialogBody>
          <DialogFooter>
            <Button
              type="submit"
              color="primary"
              data-testid={whatsappConsentModalTestId.continueButton}
              loading={submitLoading}
            >
              <FormattedMessage
                id="user.consent.whatsapp.submit"
                defaultMessage="Submit"
              />
            </Button>
          </DialogFooter>
        </form>
      </FormProvider>
    </DialogContainer>
  );
};
